import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useSelector } from 'react-redux'
import DraggableModal from './DraggableModal'
import AppImageViewer from './app-image-viewer/AppImageViewer'
import { generateFileUrl } from '../plugins/utils'

const ViewExamineeFileModal = forwardRef((props, ref) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [fileItem, setFileItem] = useState({})
  const [isPdf, setIsPdf] = useState(false)
  const envInfo = useSelector(state => state.env.envInfo)

  useImperativeHandle(ref, () => {
    return {
      showModal,
      hideModal
    }
  })

  useEffect(() => {
    setFileItem(props.fileItem)
    setIsPdf((props.fileItem?.filePath?.toLocaleLowerCase())?.includes('.pdf'))
  }, [props.fileItem])

  const showModal = () => {
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
  }

  return (
    <div ref={ ref }>
      <DraggableModal
        title={ fileItem.fileName }
        width={ 700 }
        open={ modalVisible }
        onCancel={ hideModal }
        footer={ [] }
      >
        <div>
          {
            isPdf
              ?
              <div className={ 'd-flex justify-content-center' }>
                <iframe
                  src={ generateFileUrl(envInfo, fileItem.filePath) }
                  style={ {
                    width: '100%',
                    height: '700px',
                    borderWidth: 0
                  } }
                ></iframe>
              </div>
              :
              <AppImageViewer src={ generateFileUrl(envInfo, fileItem.filePath) }></AppImageViewer>
          }

        </div>
      </DraggableModal>
    </div>
  )
})

export default ViewExamineeFileModal
